import { IIconBase } from '..'

const InfoWhiteIcon = ({ height = 14, width = 14 }: IIconBase) => {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none'>
      <g id='icon-wrapper' clipPath='url(#clip0_2429_9048)'>
        <g id='Union'>
          <path
            d='M6.99951 13.124C5.37506 13.124 3.81714 12.4787 2.66848 11.3301C1.51982 10.1814 0.874512 8.62348 0.874512 6.99902C0.874512 5.37457 1.51982 3.81665 2.66848 2.66799C3.81714 1.51933 5.37506 0.874023 6.99951 0.874023C8.62396 0.874023 10.1819 1.51933 11.3305 2.66799C12.4792 3.81665 13.1245 5.37457 13.1245 6.99902C13.1245 8.62348 12.4792 10.1814 11.3305 11.3301C10.1819 12.4787 8.62396 13.124 6.99951 13.124ZM6.99951 13.999C8.85603 13.999 10.6365 13.2615 11.9493 11.9488C13.262 10.636 13.9995 8.85554 13.9995 6.99902C13.9995 5.14251 13.262 3.36203 11.9493 2.04928C10.6365 0.736521 8.85603 -0.000976562 6.99951 -0.000976562C5.143 -0.000976562 3.36252 0.736521 2.04976 2.04928C0.73701 3.36203 -0.000488281 5.14251 -0.000488281 6.99902C-0.000488281 8.85554 0.73701 10.636 2.04976 11.9488C3.36252 13.2615 5.143 13.999 6.99951 13.999Z'
            fill='#A1A7C4'
          />
          <path
            d='M7.81326 5.76352L5.80951 6.01465L5.73776 6.34715L6.13151 6.41977C6.38876 6.48102 6.43951 6.57377 6.38351 6.83015L5.73776 9.86465C5.56801 10.6495 5.82964 11.0188 6.44476 11.0188C6.92164 11.0188 7.47551 10.7983 7.72664 10.4955L7.80364 10.1315C7.62864 10.2855 7.37314 10.3468 7.20339 10.3468C6.96276 10.3468 6.87526 10.1779 6.93739 9.8804L7.81326 5.76352ZM7.87451 3.93652C7.87451 4.16859 7.78232 4.39115 7.61823 4.55524C7.45414 4.71934 7.23158 4.81152 6.99951 4.81152C6.76745 4.81152 6.54489 4.71934 6.38079 4.55524C6.2167 4.39115 6.12451 4.16859 6.12451 3.93652C6.12451 3.70446 6.2167 3.4819 6.38079 3.31781C6.54489 3.15371 6.76745 3.06152 6.99951 3.06152C7.23158 3.06152 7.45414 3.15371 7.61823 3.31781C7.78232 3.4819 7.87451 3.70446 7.87451 3.93652Z'
            fill='#A1A7C4'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2429_9048'>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InfoWhiteIcon
